module.exports = __webpack_public_path__ + "static/media/cross.e4a2ac12.svg";